<mad-main-container class="main-container">
  <mad-content-header>
    <example-header></example-header>
  </mad-content-header>
  <mad-content-panel-container>
    <mad-content-panel-container-sidebar>
      <mad-sidebar class="sidebar-scrollable" [collapsed]="isHandset$ | async">
        <div class="version">
          <p>Addons version {{ addonsVersion }}</p>
          <p>Material version {{ materialVersion }}</p>
          <p>Angular version {{ angularVersion }}</p>
        </div>
        <mat-divider></mat-divider>
        <mat-nav-list>
          @for (entry of navigationEntries; track entry) {
            <nav-entry [entry]="entry"></nav-entry>
          }
        </mat-nav-list>
      </mad-sidebar>
    </mad-content-panel-container-sidebar>
    <mad-content-panel-container-content>
      <example-page-title></example-page-title>
      <router-outlet></router-outlet>
    </mad-content-panel-container-content>
  </mad-content-panel-container>
</mad-main-container>
